import React from 'react';
import { connect } from 'react-redux';
import { Control, Fieldset, actions } from 'react-redux-form';
import {
  PLACEHOLDER_OPT,
  baseTransferFundsPath,
} from './Schemas/baseRrf';
import Select, { SELECT_STYLE } from './Controls/Select';
import InputField from './Controls/Field';
import CurrencyField from './Controls/CurrencyField';
import Currency from '../Currency';
import { myIPOAccountID } from '../TransferFunds/utils';

import './styles.css';

const getFields = (onFromChange, onToChange, disabled) => ([
  {
    model: '.accounts.from',
    RRFComp: Control,
    control: {
      component: Select,
      selectStyle: SELECT_STYLE.BLUE,
      disabled,
      onChange: (val) => { if (val !== myIPOAccountID) onFromChange(); },
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select an account to transfer from.',
      },
    },
  },
  {
    model: '.accounts.to',
    RRFComp: Control,
    control: {
      component: Select,
      selectStyle: SELECT_STYLE.BLUE,
      disabled,
      onChange: (val) => { if (val !== myIPOAccountID) onToChange(); },
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select an account to transfer to.',
      },
    },
  },
  {
    model: '.transferAmount',
    RRFComp: Control,
    control: {
      component: CurrencyField,
      disabled,
      parser: val => (val && val.replace(/\$|,/g, '')),
      placeholder: '$0.00',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please enter the amount to be transferred.',
      },
    },
  },
]);

const UnconnectedTransferFunds = ({
  transferFundsPath,
  bankOpts,
  disabled,
  cashBalance,
  changeFromAccountMyIPO,
  changeToAccountMyIPO,
}) => {
  const fields = getFields(changeToAccountMyIPO, changeFromAccountMyIPO, disabled);
  return (
    <Fieldset model={transferFundsPath}>
      <div styleName="formLabel">From</div>
      <InputField
        key={fields[0].model}
        fieldProps={fields[0]}
      >
        {Object.keys(bankOpts).sort(a => (
          a === PLACEHOLDER_OPT ? -1 : 1)).map(key => (
            (key === PLACEHOLDER_OPT) ?
              <option key={key} disabled value={key}>{bankOpts[key]}</option>
            : <option key={key} value={key}>{bankOpts[key]}</option>
          ))}
      </InputField>
      <div styleName="formLabel">To</div>
      <InputField
        key={fields[1].model}
        fieldProps={fields[1]}
      >
        {Object.keys(bankOpts).sort(a => (
          a === PLACEHOLDER_OPT ? -1 : 1)).map(key => (
            (key === PLACEHOLDER_OPT) ?
              <option key={key} disabled value={key}>{bankOpts[key]}</option>
            : <option key={key} value={key}>{bankOpts[key]}</option>
          ))}
      </InputField>
      <div styleName="formLabel">Transfer Amount</div>
      <InputField
        key={fields[2].model}
        fieldProps={fields[2]}
      />
      <div styleName="cashAvailableRow">
        <div styleName="cashAvailable">Cash Available</div>
        <Currency styleName="cashAvailable" amount={cashBalance} />
      </div>
    </Fieldset>
  );
};

const mapDispatchToProps = (dispatch, props) => ({
  changeToAccountMyIPO: () => (dispatch(actions.change(`${baseTransferFundsPath}${props.transferFundsPath}.accounts.to`, myIPOAccountID))),
  changeFromAccountMyIPO: () => (dispatch(actions.change(`${baseTransferFundsPath}${props.transferFundsPath}.accounts.from`, myIPOAccountID))),
});


export default connect(null, mapDispatchToProps)(UnconnectedTransferFunds);



// WEBPACK FOOTER //
// ./src/components/Forms/TransferFunds.js